import { mapValues } from "../../../lib/utilities";

export const mapStoresToState = stores => mapValues(
    stores,
    store => store.getState(),
);
